import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'MID',
  category: FunctionCategory.TEXT,
  description:
    'Substring of each string in a column or a single string, taken from starting_at for number_of_characters characters.',
  shortDescription: 'Substring of a string',
  params: [
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string to substring.',
    },
    {
      name: 'starting_at',
      type: ArgType.number,
      description:
        'Either a column or number, the index from the left of the string from which to begin the substring. The first character in the string has index 1.',
    },
    {
      name: 'number_of_characters',
      type: ArgType.number,
      description: 'Either a column or number, number of characters to use in the substring.',
    },
  ],
} satisfies AnalysisFunction;
